import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import NewCellNumberSuccessSliceReducer from './NewCellNumberSuccessSlice';

export default class newCellNumberSuccessitializableModule implements IInitializableModule {
  protected name: string = 'new cell number success module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
  }

  public StartModule(context: IEpiserverContext): void {
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'newCellNumberSuccess',
      reducer: NewCellNumberSuccessSliceReducer,
    };
  }
}
